export const loggingService = {
    logMessageToConsole: (msg) => __logMessageToConsole(msg),
	logObjectToConsole: (obj, options) => __logObjectToConsole(obj, options)
}

function __logObjToConsole(obj) {
    console.log(obj);
}

function __getObjectToLog(obj, field) {
    //If we have an obj, a field and the object has the field: obj[field]
    //return that value
    if(obj && field && obj[field]) {
        return obj[field];
    }

    // optherwise just return the object
    return obj;
}

function __logMessageToConsole(msg) {
    console.log(msg);
}

function __logObjectToConsole(obj, options) {

    const bLogMessage = (options && options.messageToLog);
    let bLogMessageBefore = false;

    if(bLogMessage) {
        bLogMessageBefore = (options && options.logMessageFirst);
    }
    

    if(bLogMessage && bLogMessageBefore) {
        __logMessageToConsole(options.messageToLog);
    }    

    // If it's an array then log each element in the array
    if(Array.isArray(obj)) {
        obj.forEach((objToLog) => {
            __logObjToConsole((__getObjectToLog(objToLog, options.fieldToLog)));
        })
    } else {    //It's an object, not an array
        __logObjToConsole((__getObjectToLog(obj, options.fieldToLog)));
    }

    if(bLogMessage && !bLogMessageBefore) {
        __logMessageToConsole(options.messageToLog);
    }
}